

























































import { ProsemirrorHelper, EditorHelper } from '@getaccept/editor-lib';
import type { DropdownInputSettings, Field, MergeValues } from '@getaccept/editor-lib';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { Tooltip } from '@getaccept/lib-shared/src/types/tooltip';
import type { PropType } from '@vue/composition-api';
import { nextTick, watch, computed, defineComponent, ref } from '@vue/composition-api';
import ProsemirrorViewerFormOption from './ProsemirrorViewerFormOption.vue';

export default defineComponent({
  name: 'InputDropdown',
  components: {
    ProsemirrorViewerFormOption,
  },
  props: {
    checked: { type: Boolean },
    editable: { type: Boolean },
    fields: { type: Array as PropType<Field[]>, default: () => [] },
    input: {
      type: Object as PropType<Field & { inputSettings: DropdownInputSettings }>,
      default: () => ({}),
    },
    fieldFocused: { type: Boolean },
    mergeValues: { type: Object as PropType<MergeValues>, default: () => ({}) },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, default: () => [] },
    isPdfViewer: { type: Boolean },
    tooltip: { type: Object as PropType<Tooltip>, default: () => ({}) },
    hasUpdateError: { type: Boolean },
    isUpdating: { type: Boolean },
  },
  setup(props) {
    const isScrolling = ref(false);
    const selectedIndex = ref(0);

    const isDisabled = computed(() => !props.editable && !props.isPdfViewer);

    const preventOpenIfDisabled = (event: MouseEvent) => {
      if (!props.editable) {
        event.stopPropagation();
      }
    };

    const mergeTagValue = (mergeTag: string): string =>
      ProsemirrorHelper.getMergeValueFromMergeTag(
        ProsemirrorHelper.getTagIdFromMergeTag(mergeTag),
        props.fields,
        props.mergeValues
      );

    const showDropdownOption = (option: string): boolean => {
      const optionList = option.trim().split(' ');

      const filteredOption = optionList
        .map(item => (EditorHelper.hasMergeTags(item) ? mergeTagValue(item) : item))
        .filter(item => item !== '');

      return !!filteredOption.length;
    };

    const handleKeyEnter = () => {
      selectedIndex.value = props.input.inputSettings.options.indexOf(props.input.value);
    };

    const handleKeyUp = () => {
      if (selectedIndex.value === 0) {
        return;
      }
      selectedIndex.value--;
    };

    const handleKeyDown = () => {
      if (selectedIndex.value === props.input.inputSettings.options.length - 1) {
        return;
      }
      selectedIndex.value++;
    };

    watch(
      () => props.fieldFocused,
      (fieldFocused: boolean) => {
        if (fieldFocused) {
          const input: HTMLInputElement = document.getElementById(
            props.input.id
          ) as HTMLInputElement;
          input.focus({
            preventScroll: true,
          });
        }
      }
    );

    watch(selectedIndex, async () => {
      await nextTick();
      document.querySelector('.dropdown-content .select-option-item.selected')?.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      });
    });

    return {
      isScrolling,
      selectedIndex,
      isDisabled,
      preventOpenIfDisabled,
      handleKeyEnter,
      handleKeyUp,
      handleKeyDown,
      getDropdownValueContent: EditorHelper.getDropdownValueContent,
      getInputContent: ProsemirrorHelper.getInputContent,
      showDropdownOption,
      mergeTagValue,
    };
  },
});
